import type { HomeHeroBannerTexts, HomeHeroContent } from '../models/home-hero-content.model';
import { prepareHeroFieldHtml } from './home-hero-html.util';

/**
 * Mapeo B.2 — registro único `Bienvenido`:
 * - `titulo` → eyebrow (HTML con clases Figma o texto plano)
 * - `nombreBoton` → título principal
 * - `contenido` → subtítulo
 */
export function mapHeroBannerToContent(
  banner: HomeHeroBannerTexts,
  fallback: HomeHeroContent
): HomeHeroContent {
  const eyebrowRaw = banner.titulo?.trim();
  const titleRaw = banner.nombreBoton?.trim();
  const subtitleRaw = banner.contenido?.trim();

  if (!eyebrowRaw && !titleRaw && !subtitleRaw) {
    return fallback;
  }

  return {
    ...fallback,
    eyebrowHtml: eyebrowRaw
      ? prepareHeroFieldHtml(eyebrowRaw, 'eyebrow')
      : fallback.eyebrowHtml,
    titleHtml: titleRaw
      ? prepareHeroFieldHtml(titleRaw, 'title')
      : fallback.titleHtml,
    subtitleHtml: subtitleRaw
      ? prepareHeroFieldHtml(subtitleRaw, 'subtitle')
      : fallback.subtitleHtml,
  };
}
